import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { LoginInput } from '../components/LoginForm.schema';
import { authQueries } from '../queries';
import { authService } from '../services/authService';

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: LoginInput) => authService.login(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: authQueries.all() }),
  });
}
